/**
 * /pilot/apply — single-purpose route for the "plan my migration" form.
 *
 * The form itself lives in PilotApplicationForm so /pilot can embed it
 * inline (no 3-click hop from the landing page through a separate
 * page). This route keeps a hero treatment for prospects who arrived
 * via a direct link. (Route + component names keep "pilot" because the
 * endpoint /public/pilot-applications and the links still use it; the
 * launch pilot offer itself closed 2026-11-01.)
 */
import { Link } from "react-router-dom";

import { Pill } from "../../lib/Pill";
import { useSeo } from "../../lib/useSeo";
import { PilotApplicationForm } from "./PilotApplicationForm";

export function PilotApplyPage() {
  useSeo({
    title: "Plan your NestPlot migration",
    description:
      "Tell us about your operation and the NestPlot team will plan your migration — included on every plan, no setup fee. We reply within 1 business day. Or start a 30-day free trial, no card.",
    path: "/pilot/apply",
  });

  return (
    <div className="mx-auto max-w-[780px] px-5 lg:px-8 py-12 lg:py-16">
      <div className="mb-8">
        <Pill tone="accent" size="sm">
          Migration included
        </Pill>
        <h1 className="t-display-xl mt-4">Plan your migration.</h1>
        <p className="text-sub mt-3 max-w-[560px]">
          A few quick questions so the NestPlot team can plan how we take over
          from your current software. We reply within 1 business day. Prefer to
          dive in first?{" "}
          <Link to="/signup" className="text-accent font-semibold">
            Start your 30-day trial
          </Link>
          .
        </p>
      </div>
      <PilotApplicationForm />
    </div>
  );
}
